import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import Slider from "react-slick"

// Utils
import isMobile from "components/Stacker/utils/device-check"
import queryString from "query-string"

import TC from "components/Stacker/constants/TrackingConstants"

// Components
import SlickArrow from "components/Stacker/components/SlickArrow/SlickArrow"
import StackItWithModal from "components/Stacker/components/StackItWithModal/StackItWithModal"
import LinkAdapter from "components/Stacker/components/LinkAdapter/LinkAdapter"

// Config
import ModalConfig from "components/Stacker/config/ModalConfig"
import IPC from "components/Stacker/config/ImagePresetsConfig"

// Actions
import ModalGeneric from "components/Stacker/components/ModalGeneric/ModalGeneric"
import { toggleModal } from "components/Stacker/actions/ModalActions"
import {
  updateSelectedStackInfo,
  getProductStackList,
} from "components/Stacker/actions/StackItWithActions"

import "./ProductStackItWith.scss"
import { getDY_SR } from "stackerConfig"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"

// this should hold the Product Stack It With on PDP page.
function ProductStackItWith({
  baseStore,
  productId,
  selectedVariant: { code: productCode },
}) {
  const dispatch = useDispatch()
  const { LL } = useI18nContext()

  useEffect(() => {
    dispatch(getProductStackList({ productCode, baseStore }))
  }, [productCode, baseStore])

  const {
    baseUrl,
    stackItWith: { stackItBundle = [], isEngagementStack },
  } = useSelector((state) => {
    return {
      baseUrl: state.application.baseURL,
      stackItWith: state.pdp.stackItWith,
    }
  })

  const renderProductImage = (stack) => {
    const isMobileScreen = isMobile()
    let imgPreset
    if (isMobileScreen) {
      imgPreset = `$${IPC.STACK_IT_PDP_MOBILE}$`
    } else {
      imgPreset = `$${IPC.STACK_IT_PDP_DESKTOP}$`
    }
    return stack.stackProducts.map((item, index) => (
      <img
        key={`stack-product-img-${index}`}
        src={`${item.imageUrl}?${imgPreset}&fmt=png-alpha`}
        alt={item.productCode}
      />
    ))
  }

  const handleCustomizeClick = () => {
    const products = stackItBundle[0].stackProducts
    const bracelets = products
      .reverse()
      .filter((item) => !Object.keys(item).includes("builderTemplate"))
    const queryObj = {
      products: bracelets.map((product) => product.productCode),
    }
    const queryParamsString = queryString.stringify(queryObj, { encode: true })
    const url = `${baseUrl}${
      getDY_SR().config.braceletStacker
    }?${queryParamsString}`
    window.location.href = url
  }

  const handleModalClick = () => {
    dispatch(toggleModal(ModalConfig.MODAL_STACK_IT_WITH, true))
  }

  const handleNextStackClick = (index) => {
    dispatch(
      updateSelectedStackInfo({
        selectedIndex: index,
        selectedStack: stackItBundle[index],
      })
    )
  }

  const renderProductStack = () => {
    const arr = stackItBundle.map((stack, i) => (
      <section className="stack-group" key={`stack-group-${i}`}>
        <div
          className={`item-img-container stack-length-${stack.stackProducts.length}`}
        >
          {renderProductImage(stack)}
        </div>
      </section>
    ))
    return arr
  }

  const renderEngagementProductStack = () => {
    const isMobileScreen = isMobile()

    let imgPreset
    if (isMobileScreen) {
      imgPreset = `$${IPC.STACK_IT_PDP_MOBILE}$`
    } else {
      imgPreset = `$${IPC.STACK_IT_PDP_DESKTOP}$`
    }

    const arr = stackItBundle.map((stack, i) => {
      const filteredStackProducts = stack.stackProducts.filter((item) => {
        return item.productCode !== stack.sourceProductCode
      })
      return (
        <section className="engagement-stack-group" key={`stack-group-${i}`}>
          <div className="engagement-item-img-container">
            <img
              src={`${stack.stackImageUrl}?${imgPreset}`}
              alt={stack.sourceProductCode}
              className="w-100"
            />
          </div>
          <div className="ProductStackItWith__btn-container">
            <LinkAdapter
              className="c-btn primary d-flex align-items-center justify-content-center"
              to={filteredStackProducts[0].productUrl}
              aria={{ label: filteredStackProducts[0].baseProductCode }}
              baseProduct={filteredStackProducts[0].baseProductCode}
            >
              {LL.stackItWith.engagementStackCTA()}
            </LinkAdapter>
          </div>
        </section>
      )
    })
    return arr
  }

  if (!stackItBundle.length) {
    return null
  }
  const isMobileScreen = isMobile()

  const settings = {
    accessibility: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: isMobileScreen && isEngagementStack,
    speed: 500,
    initialSlide: 0,
    nextArrow: <SlickArrow iconName="icon-carousel-arrow-right" />,
    prevArrow: <SlickArrow iconName="icon-carousel-arrow-left" />,
    afterChange: (index) => {
      handleNextStackClick(index)
    },
  }

  // const isRing = productCode.substring(0, 1) === 'R' || productCode.substring(0, 1) === 'W';
  const isBracelet = productCode.substring(0, 1) === "B"

  return (
    <article className="ProductStackItWith container">
      <div className="ProductStackItWith__wrapper">
        <div className="ProductStackItWith__text text-center">
          <h3>
            {isEngagementStack
              ? LL.tackItWith.engagementPerfectBandsTitle()
              : LL.stackItWith.title()}
          </h3>
          <p>
            {isEngagementStack
              ? LL.stackItWith.engagementPerfectBandsDescription()
              : LL.stackItWith.description()}
          </p>
        </div>
        {isEngagementStack ? (
          <div className="ProductStackItWith__slider text-center engagement-stack-slider">
            <Slider {...settings}>{renderEngagementProductStack()}</Slider>
          </div>
        ) : (
          <div className="ProductStackItWith__slider text-center">
            <Slider {...settings}>{renderProductStack()}</Slider>
            <div className="ProductStackItWith__btn-container">
              <div className="d-flex justify-content-center">
                {isBracelet && (
                  <button
                    className="c-btn primary d-flex align-items-center justify-content-center"
                    onClick={handleCustomizeClick}
                  >
                    {LL.stackItWith.customize()}
                  </button>
                )}
                <button
                  className="c-btn primary d-flex align-items-center justify-content-center"
                  onClick={handleModalClick}
                >
                  {LL.stackItWith.stackCTA()}
                </button>
              </div>
            </div>
            <ModalGeneric
              title={LL.stackItWith.title()}
              name={ModalConfig.MODAL_STACK_IT_WITH}
              standard
            >
              <StackItWithModal productId={productCode} />
            </ModalGeneric>
          </div>
        )}
      </div>
    </article>
  )
}

ProductStackItWith.propTypes = {
  baseStore: PropTypes.string,
  productId: PropTypes.string,
  selectedVariant: PropTypes.object,
}

export default ProductStackItWith
